// -----------------------------------------------------------------------------
// LoadingScreen — Écran de chargement initial (en attendant Firebase Auth)
// StockPro / VisualisPro
// -----------------------------------------------------------------------------

import { Ic, ICONS } from "./Icons";

export default function LoadingScreen({ dark }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: dark ? "#070711" : "#f0f2f8",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: 16,
      }}
    >
      <div
        style={{
          width: 44,
          height: 44,
          background: "linear-gradient(135deg,#FF6B35,#f7931e)",
          borderRadius: 13,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Ic d={ICONS.box} size={22} color="#fff" />
      </div>
      <span
        style={{
          display: "inline-block",
          width: 24,
          height: 24,
          border: "3px solid rgba(255,107,53,.2)",
          borderTopColor: "#FF6B35",
          borderRadius: "50%",
          animation: "spin .8s linear infinite",
        }}
      />
      <p style={{ color: dark ? "#444" : "#aaa", fontSize: 13 }}>
        Connexion en cours...
      </p>
    </div>
  );
}
